import { useState, useEffect } from 'react';

const useOverflow = () => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [node, setNode] = useState(null);
  useEffect(() => {
    if (node) {
      const offsetHeight = node.offsetHeight;
      const scrollHeight = node.scrollHeight;
      if (scrollHeight - offsetHeight > 2) {
        setIsOverflowing(true);
      }
    }
  }, [node]);
  return [isOverflowing, setNode];
};

export { useOverflow };
//# sourceMappingURL=useOverflow.es.js.map
